<template>
  <a-button class="header-action-btn" type="default" @click="handleEventOpen">
    <template #icon><UserOutlined /></template>
    {{ title || '个人资料' }}
  </a-button>
  <a-drawer
      v-model:open="openStatus"
      class="custom-class"
      root-class-name="root-class-name"
      :root-style="{ color: 'blue' }"
      title="个人资料"
      width="28%"
      @close="handleEventClose"
      placement="right"
      :destroy-on-close="true"
      :keyboard="false"
      :maskClosable="false"

  >

    <div>

      <div style="margin: 0 auto;text-align: center">
        <div>
          <a-avatar :size="size" :style="{ backgroundColor: color, verticalAlign: 'middle' }">

          </a-avatar>
        </div>

        <CommonDivider :height="10"/>
        <div>Admin</div>
        <CommonDivider :height="10"/>
        <ChangePassword/>


      </div>



    </div>



    <template #extra>
      <a-button style="margin-right: 8px" @click="handleEventClose">关闭</a-button>
    </template>


  </a-drawer>



</template>

<script setup>

import {Form} from "ant-design-vue";
import {ref} from "vue";
import {UserOutlined} from "@ant-design/icons-vue";
import CommonDivider from "@/components/components_common/other/CommonDivider.vue";
import ChangePassword from "@/components/components_business/user/ChangePassword.vue";
const color = ref('#f56a00');
const size = ref(100);

defineProps({
  title: {
    type: String,
    default: '个人资料',
  },
})

const openStatus = ref(false)

const handleEventOpen = () => {
  openStatus.value = true
}
const handleEventClose = () => {
  openStatus.value = false
}


</script>
